import { z } from 'zod/v4';

/**
 * Use this to validate back end data that returns the numerical value for an enumeration.
 * @param schema ZodEnum schema
 * @param enumOptions array of ZodEnum options
 * @returns Zod preprocess function with ZodNativeEnum as schema
 */
export function createEnumSchemaPreprocessor<T extends z.ZodTypeAny>(
  schema: T,
  enumOptions: readonly string[]
) {
  return z.preprocess(
    (value) =>
      typeof value === 'number' && value >= 0 && value < enumOptions.length
        ? enumOptions[value]
        : value,
    schema
  );
}
